<template>
  <div class="bl_area capture_area">
    <form
      id="frm_container"
      @submit.prevent
    >
      <h2 class="content_title">B/L Body Detail</h2>

      <table class="tbl_col mt10 tbl_mark">
        <colgroup>
          <col width="41%">
          <col width="56%">
          <col width="3%">
        </colgroup>
        <thead>
          <tr>
            <th class="text_left">
              Mark & No
            </th>
            <th></th>
            <th>
              <button
                class="tbl_icon plus"
                @click="addMarkDesc"
              >
                plus
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(vo, idx) in regParams.houseBlDescList" :key="'markDesc_' + idx">
            <td class="td_mrk">
              <ETextarea2 :id="'mrk_' + idx"
                          :max-line="18"
                          :column-length="25"
                          v-model="vo.mrk"
                          :value="vo.mrk"
                          :is-upper="true"
                          :padding-right="223"
              />
            </td>
            <td class="td_desc">
              <ETextarea2 :id="'dscr_' + idx"
                          :max-line="18"
                          :column-length="45"
                          class="txt_dscr"
                          :is-upper="true"
                          v-model="vo.dscr"
                          :value="vo.dscr"
                          :padding-right="383"
              />
            </td>
            <td>
              <button
                v-if="idx !== 0"
                class="tbl_icon minus"
                @click="removeMarkDesc(idx)"
              >
                minus
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <win-layer-pop>
      <component
        :is="customComponent"
        v-if="customComponent"
        :parent-info="popParams"
        @close="closePopup"
        @selectFunc="selectFunc"
        @child="getChildData"
      />
    </win-layer-pop>

    <component
      v-if="commonBLComponent"
      :is="commonBLComponent"
      :parent-info="commonBLParams"
      ref="commonBL"
      @callback="commonBLCallback"
    />
  </div>
</template>

<script>
import { rootComputed } from '@/store/helpers'
import commons from '@/api/services/commons'
import trans from '@/api/rest/trans/trans'
import transCommon from '@/api/rest/trans/transCommon'
import schedule from '@/api/rest/schedule/schedule'
import BookingScheduleInfo from '@/components/trans/BookingScheduleInfo'
import EInputNumber from '@/components/common/EInputNumber'
import EDatePicker from '@/components/common/EDatePicker'
import ETransStringCheckInput from '@/components/trans/ETransStringCheckInput'
import ETransAddressInput from '@/components/trans/ETransAddressInput'
import ETransAddressTextarea from '@/components/trans/ETransAddressTextarea'
import ETransStringCheckCneeInput from '@/components/trans/ETransStringCheckCneeInput'
import ETextareaLineColumn from '@/components/common/ETextareaLineColumn'
import commonUtils from '@/plugins/commonUtils'
import blAttach from '@/api/rest/trans/blAttach'
//
import ETextarea from '@/components/common/ETextarea'
import ETextarea2 from '@/components/common/ETextarea2'

export default {
  name: 'WorkingHouseBlContainerInfo',
  components: {
    ETextarea,
    ETextarea2,
    //
    BookingScheduleInfo,
    EInputNumber,
    EDatePicker,
    ETransStringCheckInput,
    ETransAddressInput,
    ETransAddressTextarea,
    ETransStringCheckCneeInput,
    ETextareaLineColumn,
    'win-layer-pop': () => import('@/pages/trans/popup/WinLayerPop'),
    'bl-agent-address-pop': () => import('@/pages/trans/popup/BLAgentAddressPop'),
    'bl-on-board-date-pop': () => import('@/pages/trans/popup/BLOnBoardDatePop'),
    'bl-container-rf-pop': () => import('@/pages/trans/popup/BLContainerRFPop'),
    'bl-container-oog-pop': () => import('@/pages/trans/popup/BLContainerOOGPop'),
    'bl-container-dg-pop': () => import('@/pages/trans/popup/BLContainerDGPop'),
    'bl-container-cgo-pop': () => import('@/pages/trans/popup/BLContainerCgoPop'),
    'hs-code-ir-pop': () => import('@/pages/trans/popup/HsCodeIRPop'),
    'hs-code-id-pop': () => import('@/pages/trans/popup/HsCodeIDPop'),
    'hs-code-in-pop': () => import('@/pages/trans/popup/HsCodeINPop'),
    'bl-call-pop': () => import('@/pages/trans/popup/BLCallPop'),
    'common-bl': () => import('@/pages/trans/CommonBL'),
    'bl-attach-pop': () => import('@/pages/trans/popup/BLAttachPop'),
    'sr-notice-pop': () => import('@/pages/trans/popup/SrNoticePop'),
    'bl-copy-pop': () => import('@/pages/pdf/popup/BlCopyPop'),
    'bl-copy-pop-temp': () => import('@/pages/pdf/popup/BlCopyPopTemp'),
    'iran-upload-pop': () => import('@/pages/trans/popup/IranUploadPop'),
    'ca-request-pop': () => import('@/pages/trans/popup/CARequestPop'),
    'shipping-log-bl-detail-pop': () => import('@/pages/trans/popup/ShippingLogBLDetailPop'),
    'house-bl-pop': () => import('@/pages/trans/popup/HouseBlPop')
  },
  props: {
    parentInfo: {
      type: Object,
      default: () => {
          return []
      }
    }
  },
  data () {
    return {
      cstInfoList: [],
      lang: '',
      usrCtrCd: '',
      cstCatCd: '',
      blgPlcCd: '',
      saveFlag: 'BL_EDIT',
      selectBeforeVal: '',
      commonCodes: {},
      plcEnmCodes: {},
      cstEnmCodes: {},
      ctrCdList: [],
      ctrCdIccList: [],
      actCstIdList: [],
      cneCstIdList: [],
      notiCstIdList: [],
      cgoTypCdList: [],
      cntrRfStsList: [],
      issPlcList: [],
      frtPayPlcList: [],
      topMarkList: [],
      topDscrList: [],
      blEdiTypCdList: [],
      blPhbtList: [],
      deckCdList: [],
      indiaCityList: [],
      blCopyOpen: 'N',
      blRequestOpen: 'N',
      vgmPopOpen: 'N',
      isCstId: false, // Company ID 입력란 생성 여부
      addrStr: '',
      isPolHsMulti: false,
      isPodHsMulti: false,
      saveCntrCnt: 1,
      customComponent: null,
      popParams: {},
      selectFunc: {},
      commonBLComponent: null,
      commonBLParams: {},
      commonBLCallback: null,
      porPlcNmType: 'select',
      polPortNmType: 'select',
      podPortNmType: 'select',
      dlyPlcNmType: 'select',
      freeTime: '',
      serverYear: '',
      serverMonth: '',
      serverDay: '',
      serverHour: '',
      serverMin: '',
      saveType: '',
      dscrStr: '',
      byStr: '',
      timeFlag: '',
      elDateFlag: '',
      blDetailDis: '',
      descrCaYn: '',
      cgoRest: '',
      closeEl: false, // E/L 정보 수정 불가 여부
      closeCntr: false, // 컨테이너 정보 수정 불가 여부
      rfDisabled: false,
      uploadFile: true,
      isBlAdd: true,
      isShipperLOI: false,
      isShipperLOIPlc: true, // Shipper LOI 첨부 가능지역여부
      excelUploadShow: true,
      saveShipperLOI: '',
      phbtAlertMsg: [],
      originParams: {},
      originCntrLen: 0, // 조회됐을때 컨테이너 Length. (originParams는 1차 가공된 정보라서 별도 변수 생성)
      pkgInfo: '',
      docPicNo: '',
      hsChkParams: {
        maxlengthPolHsCd: '6',
        maxlengthPodHsCd: '6',
        hscdPolErrorMessage: '',
        hscdPodErrorMessage: '',
        polCtrCd: '',
        podCtrCd: '',
        polSuccYn: '',
        podSuccYn: ''
      },
      regParams: {
        bkgNo: '',
        blNo: '',
        docPicNo: '',
        bizPicNm: '',
        bizPicTelPlcNo: '',
        bizPicTelOfcNo: '',
        bizPicFaxPlcNo: '',
        bizPicFaxOfcNo: '',
        bizPicMbpBsnNo: '',
        bizPicMbpOfcNo: '',
        bizPicEmlAddr: '',
        docPicNm: '',
        docPicEmlAddr: '',
        docPicTelPlcNo: '',
        docPicTelNo: '',
        docPicFaxPlcNo: '',
        docPicFaxNo: '',
        docPicMbpBsnNo: '',
        docPicMbpNo: '',
        shprCstEnm: '',
        shprCstAddr: '',
        actShprCstCtrCd: '',
        actShprStateCd: '',
        cneCstCtrCd: '',
        cneCstStateCd: '',
        cneCstEnm: '',
        cneCstAddr: '',
        cneNatlId: '', // 도착국가 : 이란
        ntifCstCtrCd: '',
        ntifCstStateCd: '',
        ntifCstEnm: '',
        ntifCstAddr: '',
        ntfyNatlId: '', // 도착국가 : 이란
        porPlcNm: '', // Place of Receipt
        polPortNm: '', // Port of Loading
        podPortNm: '', // Port of Discharge
        dlyPlcNm: '', // Place of Delivery
        lstDestPlcNm: '', // Final Destination
        obrdDt: '',
        frtPncCd: 'P',
        polShtmCd: '',
        podShtmCd: '',
        grsCbm: '',
        grsWt: '',
        actShprIdCatCd: '',
        actShprIdNo: '',
        cneIdCatCd: '',
        cneIdNo: '',
        ntifIdCatCd: '',
        ntifIdNo: '',
        acidNo: '',
        cneAcidNo: '',
        blDclrYn: 'N',
        issCtrCd: '',
        issPlcCd: '',
        frtPayCtrCd: '',
        frtPayPlcCd: '',
        frtAppNo: '',
        cstBidgMgrNo: '',
        hsCd: '',
        podHsCd: '',
        podHsCdNm: '',
        machineRmk: '',
        blTypCd: '',
        orgBlTypCd: '',
        exportLicenseList: [],
        containerList: [],
        markDescList: [],
        reqList: [],
        addBkgNoList: [],
        cnCaFlag: 'Y',
        tsCgoChoYn: '',
        consCgoYn: '',
        etcYn: '',
        cneBinNo: '',
        ntifBinNo: '',
        amsType: '',
        amsSendYn: '',
        imShprTaxId: '',
        imCneTaxId: '',
        imNtifTaxId: ''
      },
      updateBLParams: {
        blMaster: [],
        mrkMaster: [],
        cntrMaster: [],
        liceMaster: []
      },
      uploadFileList: [],
      timer: null,
      sayChk: true,
      vueMode: true, //process.env.VUE_APP_MODE !== 'PRD'
      autoSayYn: 'N',
      templateCd: 'A',
      templateNo: '',
      templateNo_2: '',
      templateList: [],
      checkCgoType: 'Y',
      blTypeVisibleContry: [],
      fmcShprEnm: '',
      fmcCneEnm: '',
      fmcEnmList: [],
      orderYn: false,
      cntrNoArr: []
   }
  },
  computed: {
    ...rootComputed
  },
  watch: {
  },
  mounted () {
    if (this.regParams.caYn === 'Y') {
      $('#frm_container input,#frm_container select,#frm_container .plus,#frm_container .minus,#frm_container textarea').prop('disabled', true)
    }
  },
  created () {
    this._ = require('lodash')
    this.regParams.bkgNo = this.detailBkgNo
    this.regParams.blNo = this.detailBlNo

    if (this.$ekmtcCommon.isNotEmpty(this.newBlNo)) {
      this.regParams.blNo = this.newBlNo
    }

    if (this.auth !== undefined) {
      this.lang = this.$ekmtcCommon.isNotEmpty(this.auth.serviceLang) ? this.auth.serviceLang : 'KOR'
      this.cstCatCd = this.auth.cstCatCd
    }

    if (this.memberDetail !== undefined) {
      this.bkgPlcCd = this.memberDetail.bkgPlcCd
      this.usrCtrCd = this.memberDetail.userCtrCd
    }

    if (this.$ekmtcCommon.isNotEmpty(this.detailBlNo)) {
      this.saveFlag = 'BL_EDIT'
    }

    this.init()
  },
  methods: {
    async init () {
      this.regParams = this.parentInfo.houseBlList

      // Mark & No(B/L Body Detail) 초기화 (기존 CargoInfo.init 로직 이동)
      if (!this.regParams.houseBlDescList) {
        this.$set(this.regParams, 'houseBlDescList', [])
      }

      if (this.$ekmtcCommon.isEmpty(this.regParams.houseBlDescList)) {
        this.addMarkDesc()
      }

      this.fnCommonBtnAction('')
      const arrCdId = ['01099', '01032', '01130', '01031', '01068', '01033', '01038', '01208', '01278', 'CS038', '00003', 'CS003', 'CS004', 'EQ051', '01291', 'CS105', 'WB208']
      await commons.getCommonsCodesCommon(arrCdId).then(res => {
        this.commonCodes = res

        const cgoTypCdList = this.commonCodes['01038'].filter(vo => vo.cd !== ' ' && vo.cd !== '04')
        this.cgoTypCdList = cgoTypCdList

        this.cntrRfStsList = this.commonCodes['01291']

        //bl Type display contry
        this.commonCodes.WB208.forEach((v) => {
          this.blTypeVisibleContry.push(v.cdNm)
        })
      })

      // await this.initBlBkgInfo()
      const regParams = this.regParams

      this.regParams.orgBlTypCd = this.regParams.blTypCd

      let blEdiTypCdList = this.commonCodes['01099']
      if (regParams.emptyFullYn === 'Y') {
        blEdiTypCdList = blEdiTypCdList.filter(vo => vo.cd !== 'E')
      }
      this.blEdiTypCdList = blEdiTypCdList

      const arrPlcCd = [regParams.porPlcCd, regParams.polPortCd, regParams.podPortCd, regParams.dlyPlcCd]
      const arrPromise = [
        commons.getPlcStrEnmInfo(arrPlcCd).then(res => {
          this.plcEnmCodes = res

          this.setInputType()
        }),
        commons.getCommonsCodesCountry().then(res => {
          this.ctrCdList = res

          this.checkShpperLOI()
        }),
        commons.getCommonsCodesCountry('Y').then(res => {
          this.ctrCdIccList = res
        }),
        trans.fnBlCstEnmInfo().then(res => {
          this.cstEnmCodes = res
        }),
        trans.findTopMark().then(res => {
          this.topMarkList = res
        }),
        trans.findTopDscr().then(res => {
          this.topDscrList = res
        })
      ]

      this.originParams = this._.cloneDeep(this.regParams)
    },
    sendContainerInfo () {
      return this.regParams
    },
    fnValidation (flag) {
      const frm = document.querySelector('#frm_container')
      const inputEl = frm.getElementsByTagName('input')
      for (const el of inputEl) {
        el.disabled = flag
      }

      const selectEl = frm.getElementsByTagName('select')
      for (const el of selectEl) {
        el.disabled = flag
      }

      const textareaEl = frm.getElementsByTagName('textarea')
      for (const el of textareaEl) {
        el.disabled = flag
      }

      if (flag) {
        this.closeCntr = true
        this.closeEl = true
        this.uploadFile = true
        this.rfDisabled = true
      }
    },
    fnSumValue (type) {
      const regParams = this.parentInfo.parentRegParams
      if (regParams.blEdiTypCd === 'S' && this.memberDetail.userCtrCd === 'KR') {
        regParams.exportLicenseList.forEach(e => {
          if (this.$ekmtcCommon.isEmpty(e[type]) || String(e[type]) === '0') {
            e[type] = regParams[type]
          }
        })
      }
    },
    fnPackage (actionFlag) {
      const regParams = this.regParams
      const pkgQty = regParams.pkgQty

      let retValue = ''

      let flagChange = 'N'
      let cc = ''
      let dd = 0
      let jj = ''
      let kk = ''

      const dscr = this.regParams.markDescList[0].dscr
      regParams.markDescList[0].dscr = dscr.replace(this.pkgInfo, '')

      if (this.$ekmtcCommon.isNotEmpty(pkgQty)) {
        retValue = this.$ekmtcCommon.changeNumberFormat(pkgQty, { isComma: true })
      }

      const arrDscr = dscr.split('\n')
      arrDscr.forEach((d, i) => {
        if ((d.indexOf('X20') !== -1 || d.indexOf('X40') !== -1 || d.indexOf('X45') !== -1 ||
             d.indexOf('X 20') !== -1 || d.indexOf('X 40') !== -1 || d.indexOf('X 45') !== -1)) {
          cc += d + '\n'
          ++dd
        } else {
          if (parseInt(d.trim().substring(0, 5).charAt(0)) >= 0 && parseInt(d.trim().substring(0, 5).charAt(0)) <= 9) {
            // Package 수량 체크는 2번째 라인까지만 확인
            if (i < 3 && flagChange === 'N') {
              regParams.markDescList[0].dscr = dscr.replace(d, retValue)
              flagChange = 'Y'

              /* if (d.indexOf('X20') === -1 && d.indexOf('X40') === -1 && d.indexOf('X45') === -1 && d !== this.pkgInfo) {
                jj += d.replace(this.pkgInfo, '')
              } */
            } else {
              jj += d
            }
          } else {
            jj += d
          }
          if (i !== (arrDscr.length - 1)) {
            jj += '\n'
          }
        }
      })

      if (arrDscr.length === dd) {
        kk = cc + retValue
      } else {
        kk = cc + retValue + jj
      }

      regParams.markDescList[0].dscr = kk
    },
    addMarkDesc () {
      if (this.$ekmtcCommon.isEmpty(this.regParams.houseBlDescList)) {
        this.regParams.houseBlDescList = []
      }

      const markDescList = this.regParams.houseBlDescList
      const markSeq = markDescList.length === 0 ? 1 : Number(markDescList[markDescList.length - 1].markSeq) + 1
      const obj = {
        markSeq: markSeq,
        fwdrBlNo: this.regParams.fwdrBlNo,
        mrk: '',
        dscr: ''
      }

      markDescList.push(obj)
    },
    removeMarkDesc (idx) {
      const markDescList = this.regParams.houseBlDescList

      markDescList.splice(idx, 1)

      if (markDescList.length === 0) {
        this.addMarkDesc()
      }
    },
    async fnCntrNoCheck (idx) {
      const regParams = this.regParams
      const containerInfo = regParams.houseBlContainerList[idx]
      const cntrNo = containerInfo.cntrNo
      const params = {
        cntrNo: cntrNo,
        bkgNo: regParams.bkgNo
      }

      let checkMyCntrNo = true

      let succFlag = true
      let result = null
      await transCommon.searchCtrCount(params).then(res => {
        if (res.headers.respcode === 'C0000') {
          result = res.data
        } else {
          succFlag = false
        }
      }).catch(() => {
        succFlag = false
      }).finally(() => {
        if (succFlag && result !== null && result !== undefined) {
          const cntrOffYn = result.cntrOffYn
          const ctrCd = result.ctrCd
          const polCtrCd = regParams.polCtrCd
          if (cntrOffYn === 'Y') {
            // 컨테이너 Number를 확인하세요. <br>Container No. XXXX
            const failMsg = this.$t('msg.CSBL200.195') + '<br>' + this.$t('msg.CSBL200.197') + cntrNo
            this.$ekmtcCommon.alertCallback(failMsg, () => {
              containerInfo.cntrNo = ''
              containerInfo.cntrSzCd = ''
              containerInfo.cntrTypCd = ''
              frm.querySelector('#cntrNo_' + idx).focus()
            })
          } else {
            if (ctrCd === 'N') {
              containerInfo.cntrCheck = 'Y'
              return
            }
            if (this.$ekmtcCommon.isNotEmpty(ctrCd)) {
              if (polCtrCd === ctrCd) {
                containerInfo.cntrCheck = 'Y'
              } else {
                containerInfo.cntrCheck = 'N'
                if (ctrCd === 'HK' && regParams.bkgCn4Yn === 'Y') {
                  containerInfo.cntrCheck = 'Y'
                }
              }
            } else {
              containerInfo.cntrCheck = 'Y'
            }
          }
        } else {
          this.$ekmtcCommon.alertDefault(this.$t('js.common.005'))
        }
      })
    },
    openPopup (compNm) {
      this.customComponent = null
      this.customComponent = compNm

      this.$ekmtcCommon.layerOpen('.bl_area > .popup_dim')
    },
    closePopup () {
      this.customComponent = null
      this.selectFunc = null
      this.$ekmtcCommon.layerClose('.bl_area > .popup_dim')
    },
    async inputValidation () {
      const TH = this
      const type = TH.saveType
      const regParams = TH.regParams
      let isOk = true

      if (!this.checkValidationInfoAll()) {
        isOk = false
      }

      if (!this.checkValidationCntrAll()) {
        isOk = false
      }

      return isOk
    },
    async validation () {
      let isOk = true
      const TH = this
      const regParams = TH.regParams

      const cgoTypList = regParams.cgoTypList
      const containerList = regParams.containerList

      await commons.getServerTime().then(res => {
        this.serverYear = res.data.substring(0, 4)
        this.serverMonth = res.data.substring(4, 6)
        this.serverDay = res.data.substring(6, 8)
      })

      if (!await this.inputValidation()) {
        isOk = false
      }

      // JamSin if (this.lang !== 'CHN') {
        if (String(regParams.dgcount) !== '0' && String(regParams.srdgcount) === '0') {
          containerList.forEach(c => {
            if (this.$ekmtcCommon.isEmpty(c.cgoTypCd) && this.$ekmtcCommon.isNotEmpty(c.cntrNo)) {
              c.cgoCheckYn = 'N'
            } else {
              c.cgoCheckYn = 'Y'
            }
          })
        }
      //}

      return isOk
    },
    checkValidationCntrNo (idx) {
      let isOk = true
      const regParams = this.regParams
      const frm = document.querySelector('#frm_container')
      const selector = frm.querySelector('#cntrNo_' + idx)
      const cntrInfo = regParams.containerList[idx]
      const cntrTypCd = frm.querySelector('#cntrTypCd_' + idx)

      this.$ekmtcCommon.hideErrorTooltip(selector)

      if (regParams.containerList.length > 1) {
        if (this.$ekmtcCommon.isEmpty(cntrInfo.cntrNo)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('art.CMATK363'))
          isOk = false
        }

        regParams.containerList.forEach((c, i) => {
          if (i !== idx && c.cntrNo === cntrInfo.cntrNo) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('art.CMATK177'))
            isOk = false
          }
        })
      }

      if (regParams.dlyPlcCd === 'BJO' || regParams.dlyPlcCd === 'LUU' || regParams.dlyPlcCd === 'ROQ') {
        if (cntrInfo.cntrNo.startsWith('MAXU') || cntrInfo.cntrNo.startsWith('INNU') || cntrInfo.cntrNo.startsWith('IRNU') || cntrInfo.cntrNo.startsWith('RALU')) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200.160'))
          isOk = false
        }
      }

      return isOk
    },
    checkValidationInfoAll () {
      let isOk = true
      const regParams = this.regParams
      const arrEl = ['porPlcNm', 'polPortNm', 'podPortNm', 'dlyPlcNm', 'shprCstEnm', 'cneCstEnm', 'ntifCstEnm',
                      'grsWt', 'pkgQty', 'hsCd', 'podHsCd', 'cgoCont', 'amsType', 'fmcShprEnm', 'fmcCneEnm']

      let cneeChkYn = 'Y'
      let ntifChkYn = 'Y'

      const cneAfrList = this.commonCodes.CS003
      const ntifAftList = this.commonCodes.CS004

      if (Number(this.regParams.jpPodCount) > 0 && Number(this.regParams.cnPodCount) > 0) {
        const cneCstInfo = cneAfrList.filter(vo => vo.cdNm === this.regParams.cneCstEnm)
        if (cneCstInfo !== null && cneCstInfo !== undefined && cneCstInfo.length > 0) {
          cneeChkYn = 'N'
        }

        const ntifCstInfo = ntifAftList.filter(vo => vo.cdNm === this.regParams.ntifCstEnm)
        if (ntifCstInfo !== null && ntifCstInfo !== undefined && ntifCstInfo.length > 0) {
          ntifChkYn = 'N'
        }
      }

      if ((regParams.cgoModeCd === '01' || regParams.cgoModeCd === '03')) {
        if (Number(regParams.jpPodCount) > 0) {
          const addEl = ['actShprCstTelNo']
          if (ntifChkYn === 'Y') {
            addEl.push('cneCstTelNo')
            addEl.push('ntifCstTelNo')
          }

          addEl.forEach(el => {
            arrEl.push(el)
          })
        }

        if (Number(regParams.cnPodCount) > 0) {
          const addEl = ['actShprCstPicNm', 'actShprCstTelNo', 'cneCstPicNm', 'cneCstTelNo', 'ntifCstPicNm', 'ntifCstTelNo']
          addEl.forEach(el => {
            arrEl.push(el)
          })
        }

        if (Number(regParams.cnPodCount) > 0 || Number(regParams.shaPodTsCount) > 0) {
          const addEl = ['actShprIdNo', 'cneIdNo', 'ntifIdNo']
          addEl.forEach(el => {
            arrEl.push(el)
          })
        }
      }

      if (regParams.polPortCd === 'PKG' || regParams.polPortCd === 'PKW' || regParams.polCtrCd === 'MY') {
        const addEl = ['actShprIdCatCd', 'cneIdNo', 'ntifIdNo']
        addEl.forEach(el => {
          arrEl.push(el)
        })

        if (regParams.polPortCd === 'PKG' || regParams.polPortCd === 'PKW') {
          arrEl.push('actShprIdNo')
        }
      }

      if (regParams.polPortCd === 'SHA' || regParams.polShaTsYn === 'Y') {
        let addEl = []
        //if (regParams.cneCstEnm.indexOf('TO ORDER') === -1) {
          if (cneeChkYn === 'Y') {
            addEl.push('cneIdCatCd')
            addEl.push('cneIdNo')
          }
          if (this.$ekmtcCommon.isEmpty(regParams.cneIdCatCd) &&
              this.$ekmtcCommon.isNotEmpty(regParams.cneIdNo)) {
            addEl.push('cneIdCatCd')
          }

          if (this.$ekmtcCommon.isNotEmpty(regParams.cneIdCatCd) &&
              this.$ekmtcCommon.isEmpty(regParams.cneIdNo)) {
            addEl.push('cneIdNo')
          }
        //}

        addEl.forEach(el => {
          arrEl.push(el)
        })
      }

      if (regParams.polCtrCd === 'IN') {
        const addEl = ['actShprCstCtrCd', 'actShprCstCityNm', 'actShprPostNo', 'actShprCstPicNm', 'actShprCstTelNo', 'actShprCstFaxNo', 'actShprCstEmlAddr',
                        'cneCstCtrCd', 'cneCstCityNm', 'cneCstPostNo', 'cneCstPicNm', 'cneCstTelNo', 'cneCstFaxNo', 'cneCstEmlAddr',
                        'ntifCstCtrCd', 'ntifCstCityNm', 'ntifCstPostNo', 'ntifCstPicNm', 'ntifCstEmlAddr',
                        'iecNo', 'invValCurCd', 'invValExp'
                      ]
        addEl.forEach(el => {
          arrEl.push(el)
        })

        if (regParams.actShprCstCtrCd === 'IN') {
          arrEl.push('actShprStateCd')
        } else {
          arrEl.push('actShprStateNm')
        }
        if (regParams.cneCstCtrCd === 'IN') {
          arrEl.push('cneCstStateCd')
        } else {
          arrEl.push('cneCstStateNm')
        }

        if (regParams.ntifCstCtrCd === 'IN') {
          arrEl.push('ntifCstStateCd')
        } else {
          arrEl.push('ntifCstStateNm')
        }
      }

      if (regParams.inTsYn === 'Y') {
          const addEl = ['actShprCstCtrCd', 'actShprCstCityNm', 'cneCstCtrCd', 'cneCstCityNm', 'ntifCstCtrCd', 'ntifCstCityNm']
          addEl.forEach(el => {
            arrEl.push(el)
          })
        }

      if (regParams.polCtrCd === 'ID') {
        let addEl = ['etTaxNo', 'bzplcDsthNo']
        addEl.forEach(el => {
          arrEl.push(el)
        })
      }

      if (regParams.podCtrCd === 'ID' || regParams.podCtrCd === 'JO' || regParams.podCtrCd === 'TZ' || regParams.podCtrCd === 'VN') {
        let addEl = ['idTaxNo']
        addEl.forEach(el => {
          arrEl.push(el)
        })
      }
      if (regParams.podCtrCd === 'EG') {
        let addEl = ['acidNo', 'cneAcidNo']
        addEl.forEach(el => {
          arrEl.push(el)
        })
      }
      if (regParams.podCtrCd === 'IN') {
        let addEl = ['actShprCstCtrCd', 'actShprCstCityNm', 'actShprCstEmlAddr',
                      'cneCstCtrCd', 'cneCstCityNm', 'cneCstPostNo', 'cneCstEmlAddr',
                      'ntifCstCtrCd', 'ntifCstCityNm', 'ntifCstPostNo', 'ntifCstEmlAddr', 'iecNo', 'ntifPanNo',
                      'invValCurCd', 'invValExp'
                    ]
        addEl.forEach(el => {
          arrEl.push(el)
        })

        if (regParams.actShprCstCtrCd === 'IN') {
          arrEl.push('actShprStateCd')
        } else {
          arrEl.push('actShprStateNm')
        }

        if (regParams.cneCstCtrCd === 'IN') {
          arrEl.push('cneCstStateCd')
        } else {
          arrEl.push('cneCstStateNm')
        }

        if (regParams.ntifCstCtrCd === 'IN') {
          arrEl.push('ntifCstStateCd')
        } else {
          arrEl.push('ntifCstStateNm')
        }
      }

      if (regParams.podCtrCd === 'VN') {
        if (regParams.cneCstEnm.indexOf('TO ORDER') === -1) {
          arrEl.push('cneCstTelNo')
          arrEl.push('cneCstEmlAddr')
        } else {
          arrEl.push('ntifCstTelNo')
          arrEl.push('ntifCstEmlAddr')
        }
        //arrEl.push('cneCstFaxNo')
        arrEl.push('idTaxNo')
        if (regParams.wstCgoYn === 'Y') {
          arrEl.push('imLicNo')
          arrEl.push('imBnkGurNo')
        }
      }

      if (regParams.podPortCd === 'DMM') {
        arrEl.push('cneCstTelNo')
        arrEl.push('cneCstEmlAddr')
      }

      if (regParams.podPortCd === 'NSA') {
        arrEl.push('gstNo')
        arrEl.push('iecPicEmlAddr')
      }

      if (regParams.polCtrCd === 'PH' || regParams.podCtrCd === 'PH') {
        //담당자, 전화번호, 이메일
        let addEl = ['actShprCstPicNm', 'actShprCstTelNo', 'cneCstPicNm', 'cneCstTelNo', 'cneCstEmlAddr',
          'ntifCstPicNm', 'ntifCstTelNo', 'ntifCstEmlAddr'
        ]
        addEl.forEach(el => {
          arrEl.push(el)
        })
      }

      if (regParams.podCtrCd === 'BD') {
        arrEl.push('cneBinNo')
        arrEl.push('ntifBinNo')
      }

      if (regParams.dlyCtrCd === 'MX') {
        let addEl = ['actShprCstPicNm', 'actShprCstTelNo', 'actShprCstEmlAddr', 'cneCstPicNm', 'cneCstTelNo', 'cneCstEmlAddr',
          'ntifCstPicNm', 'ntifCstTelNo', 'ntifCstEmlAddr', 'podHsCd', 'grsCbm', 'imNtifTaxId', 'imShprTaxId', 'imCneTaxId'
        ]

        if (regParams.cneCstEnm.includes('BANK')) {
          addEl.pop()
          addEl.pop()
        }

        addEl.forEach(el => {
          arrEl.push(el)
        })
      }
      //미주향 Cne이메일 필수 (1643933)
      if (regParams.podCtrCd === 'US' || regParams.dlyCtrCd === 'US') {
          arrEl.push('cneCstEmlAddr')
      }

      if (regParams.polCtrCd === 'SG') {
        let addEl = ['actShprCstPicNm', 'actShprCstTelNo', 'actShprCstEmlAddr', 'cneCstPicNm', 'cneCstTelNo', 'cneCstEmlAddr',
          'ntifCstPicNm', 'ntifCstTelNo', 'ntifCstEmlAddr', 'podHsCd']

        addEl.forEach(el => {
          arrEl.push(el)
        })
      }

      arrEl.forEach(el => {
        if (!this.checkValidationInfo(el)) {
          isOk = false
        }
      })

      return isOk
    },
    checkValidationInfo (id, idx) {
      let isOk = true
      const frm = document.querySelector('#frm_container')
      const selector = frm.querySelector('#' + id)
      const regParams = this.regParams

      this.$ekmtcCommon.hideErrorTooltip(selector)

      if (id === 'blPrtSntcCont') {
        if (this.$ekmtcCommon.isNotEmpty(selector.value)) {
          if (this.regParams.blPrtSntcCont.length > 57) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200.207'))
            isOk = false
          }
        } else if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        }
      } else if (id === 'grsWt') {
        if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        } else {
          //SR 1428093 콜롬보향 중량 소수점 2자리 처리
          if (this.regParams.podPortCd === 'CMB') {
            if (selector.value.indexOf('.') > -1) {
              if (selector.value.substring(selector.value.indexOf('.') + 1).length > 2) {
                this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.550'))
                isOk = false
              }
            }
          }
        }
      } else if (id.indexOf('wt') === 0) {
        //SR 1428093 콜롬보향 중량 소수점 2자리 처리
        if (this.regParams.podPortCd === 'CMB') {
          if (selector.value.indexOf('.') > -1) {
            if (selector.value.substring(selector.value.indexOf('.') + 1).length > 2) {
              this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.550'))
              isOk = false
            }
          }
        }
      } else if (id.indexOf('grsCbm') === 0) {
        console.log('selector id @@@@@ ', id)
        console.log('selector idx @@@@@ ', idx)
        console.log('selector @@@@@ ', selector)
        // if (this.regParams.podCtrCd === 'BH' || this.regParams.dlyCtrCd === 'MX') {
          if (Number(this.regParams.grsCbm) <= 0) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.238'))
            isOk = false
          }
        // }
      } else {
        if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        }
      }

      return isOk
    },
    fnCommonBtnAction (type, path) {
      this.commonBLCallback = ''
      if (type === 'PBL' || type === 'NBL') {
        this.commonBLParams = {
          action: type,
          bkgNo: this.regParams.bkgNo,
          blNo: this.regParams.blNo,
          saveFlag: this.saveFlag
        }

        this.commonBLCallback = this.setAddSrNumberInfo
      } else if (type === 'GOLIST') {
        this.commonBLParams = {
          action: type,
          workType: 'E'
        }
      } else if (type === 'VGMPOP_SAVE' || type === 'VGMPOP_OPEN') {
        const vgmFlag = type.split('_')[1]
        this.commonBLParams = {
          action: 'VGMPOP',
          vgmFlag: vgmFlag,
          bkgNo: this.regParams.bkgNo,
          blNo: this.regParams.blNo,
          methCd: this.regParams.bkgAcpnMethCd,
          originCntrList: this.originParams.containerList,
          tareModifyYn: this.cstCatCd === 'Y' || this.regParams.shprVanYn === 'Y' ? 'Y' : 'N'
        }

        if (vgmFlag === 'SAVE') {
          this.commonBLCallback = this.refresh
        }
      } else if (type === 'ERROR_CHECK') {
        this.commonBLParams = {
          action: 'ERROR_CHECK',
          blNo: this.regParams.blNo
        }
      } else if (type === 'JPCLP') {
        this.commonBLParams = {
          action: 'JPCLP',
          blNo: this.regParams.blNo
        }
      }

      if (this.commonBLComponent === null) {
        this.commonBLComponent = 'common-bl'
      } else {
        this.$nextTick(() => {
          this.$refs.commonBL.initPageFlag()
          this.$refs.commonBL.doAction()
        })
      }
    },
    setAddSrNumberInfo (nextBlNo) {
      this.$emit('callback', nextBlNo)
    },
    fnChangeValue (caCatCd, identify, beforeValue, afterValue, element, index) {
      let compareValue = ''
      let indexValue = ''
      let count = 0

      if (beforeValue === undefined) {
        beforeValue = ''
      }

      if (afterValue === undefined) {
        afterValue = ''
      }

      const updateBLParam = this.updateBLParams

      if (caCatCd === '01') {
        count = 0
        beforeValue = beforeValue.split('@#$').join('"')
        beforeValue = beforeValue.split('`').join('\'')
        beforeValue = beforeValue.split('\\n').join('\r\n')
        afterValue = afterValue.split('@#$').join('"')
        afterValue = afterValue.split('`').join('\'')
        afterValue = afterValue.split('\\n').join('\r\n')

        updateBLParam.blMaster.forEach((vo, i) => {
          let splitValue = vo.split('@,@')[0]
          compareValue = compareValue + splitValue
          if (splitValue === identify) {
            count = i
          }
        })

        if (compareValue.indexOf(identify) <= 0) {
          updateBLParam.blMaster[updateBLParam.blMaster.length] = identify + '@,@' + beforeValue + '@,@' + afterValue + '@,@' + element
        } else {
          updateBLParam.blMaster[count] = identify + '@,@' + beforeValue + '@,@' + afterValue + '@,@' + element
        }
      } else if (caCatCd === '03') {
        count = 0
        beforeValue = beforeValue.split('@#$').join('"')
        beforeValue = beforeValue.split('`').join('\'')
        beforeValue = beforeValue.split('\\n').join('\r\n')
        beforeValue = this.$ekmtcCommon.isNotEmpty(beforeValue) ? beforeValue : ''
        afterValue = afterValue.split('@#$').join('"')
        afterValue = afterValue.split('`').join('\'')
        afterValue = afterValue.split('\\n').join('\r\n')
        afterValue = this.$ekmtcCommon.isNotEmpty(afterValue) ? afterValue : ''

        let replaceBeforeValue = []
        let replaceAfterValue = []

        if (afterValue.indexOf('DSCR') > -1) {
          const dscr = this.regParams.markDescList[0].dscr
          afterValue = '  #,#' + dscr
        }

        updateBLParam.mrkMaster.forEach((vo, i) => {
          if (this.$ekmtcCommon.isEmpty(vo)) {
            vo = '@,@@,@@,@@,@1'
          }

          if (vo.split('@,@')[4] === index) {
            replaceBeforeValue = vo.split('@,@')[1].split('#,#')
            replaceAfterValue = vo.split('@,@')[2].split('#,#')

            if (element === 'MRK') {
              beforeValue = beforeValue + replaceBeforeValue[1]
              afterValue = afterValue + replaceAfterValue[1]
              vo = identify + '@,@' + beforeValue + '@,@' + afterValue + '@,@' + element + '@,@' + index
            } else {
              beforeValue = replaceBeforeValue[0] + beforeValue
              afterValue = replaceAfterValue[0] + afterValue
              vo = identify + '@,@' + beforeValue + '@,@' + afterValue + '@,@' + element + '@,@' + index
            }

            count++
          }
        })

        if (count === 0) {
          if (String(index) === '1') {
            updateBLParam.mrkMaster[0] = identify + '@,@' + beforeValue + '@,@' + afterValue + '@,@' + element + '@,@' + index
          } else {
            if (this.$ekmtcCommon.isEmpty(updateBLParam.mrkMaster[0])) {
              updateBLParam.mrkMaster[0] = identify + '@,@' + beforeValue + '@,@' + afterValue + '@,@' + element + '@,@' + index
            }
          }
        }
      } else if (caCatCd === '05') {
        count = 0
        const cntrInfo = this.regParams.containerList[index]
        let cntrNo = cntrInfo.cntrNo

        if (this.$ekmtcCommon.isEmpty(afterValue)) {
          cntrNo = ' '
        }

        if (this.$ekmtcCommon.isEmpty(beforeValue)) {
          beforeValue = ' '
        }

        updateBLParam.cntrMaster.forEach((vo, idx) => {
          if (vo === cntrNo + '@,@' + beforeValue) {
            count++
          }
        })

        if (count === 0) {
          if (cntrNo === beforeValue) {
            return
          }

          if (cntrNo.length > 1 && cntrNo.length !== 11) {
            return
          }

          updateBLParam.cntrMaster[updateBLParam.cntrMaster.length] = cntrNo + '@,@' + beforeValue
        }

        if (this.regParams.cllCaYn === 'Y') {
          if (element === 'cntrNo') {
            this.regParams.descrCaYn = 'N'
            this.regParams.cllCntnoUpdate = 'Y'
          }
        }
      } else if (caCatCd === '07') {
        count = 0

        updateBLParam.liceMaster.forEach((vo, i) => {
          if (vo === '@,@' + beforeValue) {
            count++
          }
        })

        if (count === 0) {
          updateBLParam.liceMaster[updateBLParam.liceMaster.length] = '@,@' + beforeValue
        }
      }
    },
    async refresh () {
      this.commonBLParams = {}
      await this.init()
    },
    checkShpperLOI () {
      const regParams = this.regParams

      if (this.$ekmtcCommon.isNotEmpty(regParams.shprCstAddr)) {
        const ctrInfo = this.ctrCdList.filter(vo => vo.ctrCd === regParams.polCtrCd)[0]

        if (ctrInfo !== undefined) {
          const ctrNm = ctrInfo.ctrEnm.toUpperCase().replace(/ /g, '')
          const shprCstAddr = regParams.shprCstAddr.replace(/ /g, '')
          if (shprCstAddr.indexOf(ctrNm) === -1) {
            this.isShipperLOI = true
          } else {
            this.isShipperLOI = false
          }
        }
      } else {
        this.isShipperLOI = true
      }
    },
    setInputType () {
      if (this.$ekmtcCommon.isNotEmpty(this.regParams.porPlcCd)) {
        const porPlcList = this.plcEnmCodes[this.regParams.polPortCd] ? this.plcEnmCodes[this.regParams.porPlcCd].filter(vo => vo.plcEnm === this.regParams.porPlcNm) : ''
        if (porPlcList === undefined || porPlcList.length === 0) {
          this.porPlcNmType = 'input'
        }
      }

      if (this.$ekmtcCommon.isNotEmpty(this.regParams.polPortCd)) {
        const polPortList = this.plcEnmCodes[this.regParams.polPortCd] ? this.plcEnmCodes[this.regParams.polPortCd].filter(vo => vo.plcEnm === this.regParams.polPortNm) : ''
        if (polPortList === undefined || polPortList.length === 0) {
          this.polPortNmType = 'input'
        }
      }

      if (this.$ekmtcCommon.isNotEmpty(this.regParams.podPortCd)) {
        const podPortList = this.plcEnmCodes[this.regParams.podPortCd] ? this.plcEnmCodes[this.regParams.podPortCd].filter(vo => vo.plcEnm === this.regParams.podPortNm) : ''
        if (podPortList === undefined || podPortList.length === 0) {
          this.podPortNmType = 'input'
        }
      }

      if (this.$ekmtcCommon.isNotEmpty(this.regParams.dlyPlcCd)) {
        const dlyPlcList = this.plcEnmCodes[this.regParams.dlyPlcCd] ? this.plcEnmCodes[this.regParams.dlyPlcCd].filter(vo => vo.plcEnm === this.regParams.dlyPlcNm) : ''
        if (dlyPlcList === undefined || dlyPlcList.length === 0) {
          this.dlyPlcNmType = 'input'
        }
      }
    },
    getChildData (data) {
      if (data.type === 'SHAMF') {
        this.fnCommonBtnAction('SHAMF', 'CAREQ')
      }
    },
    showTooltip (id) {
      // console.log('showTooltip id @@@@ ', id)
      // console.log('showTooltip originParams polPortNm@@@@ ', this.originParams.polPortNm)

      const polPortNmType = this.polPortNmType
      const porPlcNmType = this.porPlcNmType
      const podPortNmType = this.podPortNmType
      const dlyPlcNmType = this.dlyPlcNmType
      const originParams = this.originParams
      const regParams = this.regParams

      switch (id) {
        case 'porTooltip':
          if (this.$ekmtcCommon.isNotEmpty(regParams.porPlcNm) && (originParams.porPlcNm !== regParams.porPlcNm) && porPlcNmType === 'input') {
            $('#' + id).show()
          }
          break
        case 'polTooltip':
          if (this.$ekmtcCommon.isNotEmpty(regParams.polPortNm) && (originParams.polPortNm !== regParams.polPortNm) && polPortNmType === 'input') {
            $('#' + id).show()
          }
          break
        case 'podTooltip':
          if (this.$ekmtcCommon.isNotEmpty(regParams.podPortNm) && (originParams.podPortNm !== regParams.podPortNm) && podPortNmType === 'input') {
            $('#' + id).show()
          }
          break
        case 'dlyTooltip':
          if (this.$ekmtcCommon.isNotEmpty(regParams.dlyPlcNm) && (originParams.dlyPlcNm !== regParams.dlyPlcNm) && dlyPlcNmType === 'input') {
            $('#' + id).show()
          }
          break
      }
    },
    hideTooltip (id) {
      $('#' + id).hide()
    },
    checkValidationCntrAll () {
      let isOk = true
      let arrEl = ['cntrNo', 'cntrSzCd', 'cntrTypCd', 'cgoTypCd']
      const regParams = this.regParams

      arrEl.forEach(el => {
        regParams.containerList.forEach((c, idx) => {
          if (!this.checkValidationCntr(el, idx)) {
            isOk = false
          }
        })
      })

      return isOk
    },
    checkValidationCntr (flag, idx) {
      console.log('checkValidationCntr flag @@@@@ ', flag)

      let isOk = true
      const regParams = this.regParams
      const frm = document.querySelector('#frm_container')
      const selector = frm.querySelector('#' + flag + '_' + idx)

      const cntrInfo = regParams.containerList[idx]
      const cgoTypList = regParams.cgoTypList

      this.$ekmtcCommon.hideErrorTooltip(selector)

      if (this.auth.userId === 'CKLINE') {
        return true
      }

      if (flag === 'cntrNo') {
        isOk = this.checkValidationCntrNo(idx)
      } else {
        if (regParams.polShtmCd === '02' && this.$ekmtcCommon.isEmpty(cntrInfo.cntrNo)) {
          return true
        }

        if (this.$ekmtcCommon.isNotEmpty(cntrInfo.cntrNo)) {
          if (flag === 'cntrSzCd' && this.$ekmtcCommon.isEmpty(selector.value)) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
            isOk = false
          } else if (flag === 'cntrTypCd' && this.$ekmtcCommon.isEmpty(selector.value)) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
            isOk = false
          }

          if (this.memberDetail.userCtrCd === 'CN' && flag === 'cgoTypCd') {
            console.log('cgoTypCd BL @@@@@ ', flag)

            cgoTypList.forEach((cgoVo, idx) => {
              if (cgoVo.cgoTypCd === '01' || cgoVo.cgoTypCd === '06') { // 부킹에서 입력한 컨테이너 cgoTypeCd 가 HZ or FB 일때
                console.log('cgoVo.cgoTypCd @@@@@ ', cgoVo.cgoTypCd)

                if (this.$ekmtcCommon.isEmpty(cntrInfo.cgoTypCd)) {
                  this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
                  isOk = false
                }
              }
            })
          }
        }
      }

      return isOk
    }
  }
}
</script>
<style scoped>
  .div_tooltip {width:230px !important; right:0; top:24px;}
  .tooltip_wrap {width:150px; right:0; top:24px; display:none;}
  .tooltip_wrap .cont {padding: 20px;}
  .txt_desc {background: inherit; position: relative;}
  .txt_desc:before {content:'※'; position: absolute; top: 0; left: 0;}
  .minus {background-position: -50px -50px;}
  .div_seal+.div_seal {margin-top: 5px;}
  .tbl_mark td{vertical-align: top;}
  .txt_desc1 {min-height: inherit; height: 45px; overflow: hidden; font-family: 'Courier New'; padding-top: 2px;}
  .txt_underline {font-weight: 500; text-decoration: underline; color: inherit; cursor: pointer;}
  .td_noline {border-left: none; border-bottom: none;}
  .tbl_btm_none {border-bottom: none !important;}
  .line_bottom {border-bottom: 1px solid #e1e3eb;}
  .no_cursor {cursor: default;}
  .no_cursor:hover { color:#5e75bf !important; border: solid 1px #a2aed2 !important;}
  .avoid_deco {
    padding-left: 0px !important;
  }
  .avoid_deco::before {
    content: '' !important;
  }
  .deck_select {
    border: solid 0px #cecece !important;
    color: black;
    background: white !important;
    padding: 0 0 0 0;
  }
</style>
